<template>
  <div class="Audios" style="width: 300px">
    <el-upload
        :action="url"
        :limit="1"
        :headers="{token:this.$store.getters.getToken}"
        :on-success="onSuccess"
        :before-upload="beforeUpload"
        :on-remove="onRemove"
        :file-list="file_list"
        with-credentials
        auto-upload>
      <div slot="tip" class="el-upload__tip">Only in MP3 format, under 20 MB</div>
      <el-button if size="medium" type="primary">Upload<i class="el-icon-upload el-icon--right"></i></el-button>
    </el-upload>
    <audio v-if="file_list.length!==0" :src="file_list[0].url" controls="controls">
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
  import {baseURL} from '@/utils/util'

  export default {
    props: ['input'],
    data: () => {
      return {
        url: `${baseURL}/bk_audio/upload`,
        file_list: []
      }
    },
    watch: {
      input: {
        handler() {
          if (this.input !== '') {
            this.file_list.push({
              name: [...this.input.split('/')].pop(),
              url: this.input
            })
          }
        },
        deep: true
      }
    },
    methods: {
      beforeUpload(file) {
        const isMP3 = file.type === 'audio/mp3' || file.type === 'audio/mpeg';
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isMP3) {
          this.$message.error(`Format error (${file.type}). Only MP3 format is accepted!`);
        }
        if (!isLt20M) {
          this.$message.error('Audio size should not exceed 20 MB');
        }
        return isMP3 && isLt20M;
      },
      onSuccess(r) {
        if (r.errcode === 0) {
          this.$emit('output', {
            audio_path: r.audio_path,
          })
        }
      },
      onRemove() {
        this.file_list=[];
        this.$emit('remove')
      }
    }
  };
</script>
